import {
  designSystemColors, otherColors,
} from '@klv/shared/styles/colors';
import type { IPricingTheme } from '../../types';

const pricing: IPricingTheme = {
  accent: designSystemColors.sageShade,
  background: designSystemColors.lightSand,
  cardBackground: designSystemColors.white,
  cardBorder: otherColors.gray40,
  dropdownBackground: designSystemColors.white,
  dropdownBorder: otherColors.gray40,
  dropdownText: designSystemColors.charcoal,
  stickyBackground: designSystemColors.sage,
  text: designSystemColors.charcoal,
  timePeriod: otherColors.gray70,
};

export default pricing;
